import React from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { tt } from "../i18n/tt";

// 메인 포털 푸터 — UserLayout 에서 그대로 떼어 냈다(2026-09-10, PartnerLayout 과 공유).
// 🔒 사업자 정보는 법적 공시 — PrivacyPolicy 와 동시에 갱신한다 (docs/pages/main/UserLayout.md).
// supportLink: 「문의하기」 링크(/support) — 파트너 포털은 문의 화면이 없어 false 로 끈다.
export default function UserFooter({ supportLink = true } = {}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      color="neutral.400"
      fontSize="xs"
      mt={2}
      px={{ base: 4, md: 8 }}
      pt={8}
      pb={{ base: "calc(72px + env(safe-area-inset-bottom))", md: 10 }}
      textAlign="center"
    >
      <Text mb={4} lineHeight="tall">
        {tt("a.footer.company", "(주) 루나르트 | 대표 권재의")} <br />
        {tt("a.footer.address", "주소 서울특별시 성동구 연무장5가길 25, 8층 804호(성수동2가, 성수역 SKV1 Tower) (주)루나르트")} <br />
        {tt("a.footer.bizno", "사업자등록번호 652-88-00793")} <br />
        {tt("a.footer.mailorder", "통신판매업 신고 2024-서울광진-0001")} <br />
        {tt("a.footer.hosting", "호스팅 서비스 Amazon Web Services · 개인정보 보호책임자 권재의")} <br />
        {supportLink && (
          <>
            <Button
              variant="link"
              color="brand.700"
              fontSize="xs"
              fontWeight="600"
              p={0}
              h="auto"
              minH="auto"
              verticalAlign="baseline"
              onClick={() => navigate("/support")}
            >
              {tt("a.4f1a014e", "문의하기")}
            </Button>
            {" · "}
          </>
        )}
        {tt("a.footer.contact", "고객 문의 contact@laeebly.com")} <br />
        {tt("a.footer.cpo", "개인정보관리책임자 김세원")} <br />
        Believe in yourself © Rhoonart Co., Ltd. All Rights Reserved.
      </Text>
      <Flex gap={2} justify="center" align="center" flexWrap="wrap">
        <Button
          variant="link"
          color="neutral.400"
          fontSize="xs"
          fontWeight="normal"
          p={0}
          h="auto"
          minH="auto"
          onClick={() => navigate('/terms-of-service')}
          _hover={{ color: "neutral.600" }}
        >
          {t("footer.terms")}
        </Button>
        <Text color="neutral.300">|</Text>
        <Button
          variant="link"
          color="neutral.400"
          fontSize="xs"
          fontWeight="normal"
          p={0}
          h="auto"
          minH="auto"
          onClick={() => navigate('/privacy-policy')}
          _hover={{ color: "neutral.600" }}
        >
          {t("footer.privacy")}
        </Button>
      </Flex>
    </Box>
  );
}
